export default {
  heading: "设定电邮转寄功能",
  userEmail: "教城电邮地址",  
  fromEmail1: "将我的教城电邮地址 ",
  fromEmail2: " 转寄至:",
  toEmail: "电邮地址",
  stopEmail: "我希望停用电邮转寄功能",
  stopForwardingAlertTitle: "停用电邮转寄功能",
  stopForwardingAlert: "停用电邮转寄功能后，您将不能再重启电邮转寄功能。",
  retireMsg: "<b><u>教城电邮转寄服务将于2027年1月31日起停止</u></b><p>为确保于电邮转寄服务停止提供后，阁下仍可透过自行管理的电邮地址接收第三方服务的通知及通讯，我们建议 阁下及早采取以下措施：</p><ul class='pl-10'><li>检查并更新相关服务账户所登记的联络电邮地址</li><li>改用可自行管理及长期有效的电邮地址作为相关服务的登记及联络电邮</li></ul><p>如 阁下需要延长服务以作相关安排，请于<b>2027年1月31日</b>前电邮至 <a href='mailto:support{'@'}edcity.hk'>support{'@'}edcity.hk</a> 提出申请，我们将按个别情况审核申请，并尽力提供适切协助。</p>",
  button: {
    back: "返回",
    stop: "停用",
  }
};
